let airports = document.querySelectorAll(".trip section.airports button");
let programAirportTabs = document.querySelectorAll(".trip section.section-program #airportToggleButtons [data-selector]");
let trips = document.querySelectorAll(".trip section.trips .js-trip");


// If you click on one of the airport buttons on the trip page, it will hide unrelated tour dates
if (airports && trips) {

    // If the URL has airport=bergen in it

    let params = new URLSearchParams(window.location.search);
    if (params.has("airport")) {
        let selectedAirport = params.get("airport");
        let button = document.querySelector(`.trip section.airports [data-airport-slug='${selectedAirport}']`);

        // Preselect the airport from the trip date filter.
        airports.forEach(a => a.classList.remove("active"));
        button.classList.add("active");

        // Preselect the "program" for the right airport
        programAirportTabs.forEach(a => a.classList.remove("active"));
        let programTabToActivate = document.querySelector(`#airportToggleButtons [data-airport-id='${airportSlug}']`);
        programTabToActivate.classList.add("active");

        trips.forEach((trip) => {
            trip.classList.add("hidden");
            if (trip.dataset.airportSlug == selectedAirport) {
                trip.classList.remove("hidden");
            }
        });

    }

    // When you click on an airport in the list
    airports.forEach((btn) => {
        btn.addEventListener("click", e => {

            let airportSlug = e.target.dataset.airportSlug;
            let airportId = e.target.dataset.airportId;

            airports.forEach(a => a.classList.remove("active"));

            if (airportId === "all") {
                trips.forEach((trip) => {
                    trip.classList.remove("hidden");
                });
                e.target.classList.add("active");
            } else {
                programAirportTabs.forEach(a => a.classList.remove("active"));

                let programTabToActivate = document.querySelector(`#airportToggleButtons [data-airport-id='${airportSlug}']`);
                if (programTabToActivate) programTabToActivate.classList.add("active");
                e.target.classList.add("active");

                trips.forEach((trip) => {
                    trip.classList.add("hidden");
                    if (trip.dataset.airport == airportId) {
                        trip.classList.remove("hidden");
                    }
                });
            }
        })
    });
}
